<template>
  <!-- 按问题找律师 -->
  <div class="ls">
    <div class="lsbanner">
      <img src="~assets/findlawchild/lsbanner.png" alt="" />
    </div>
    <div class="lslist flex_start wrap">
      <div
        class="lsitem"
        v-for="item in wentilist"
        :key="item.id"
        @click="tojump(item.id)"
      >
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wentilist: [],
    };
  },
  beforeMount() {
    this.getwenti();
  },
  methods: {
    getwenti() {
      this.$http.fdlaw
        .getQuesIfy()
        .then((res) => {
          console.log(res);
          this.wentilist = res.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    tojump(id) {
      // this.$router.push({
      //   path: "/findLawyers/lslist",
      // });
	  this.$router.push({name:'lslist',params:{problemid:id}});
    },
  },
};
</script>

<style lang="scss" scoped>
.ls {
  background-color: #fff;
  .lsbanner {
    max-width: 1920px;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .lslist {
    width: 1200px;
    padding: 50px 0 20px;
    margin: 0 auto;

    .lsitem {
      cursor: pointer;
      width: 270px;
      height: 160px;
      border-radius: 10px;
      margin-bottom: 30px;
      margin-right: 30px;
      padding: 60px 30px;
      position: relative;
      &:hover {
        color: #0465ea;
        &::after {
          background: #0465ea;
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: 95px;
        left: 30px;
        width: 22px;
        height: 3px;
        background: #b8b8b8;
      }
      &:nth-child(1n + 0) {
        background: url("~assets/findlawchild/xxitem_bg1.png");
      }
      &:nth-child(2n + 0) {
        background: url("~assets/findlawchild/xxitem_bg2.png");
      }
      &:nth-child(3n + 0) {
        background: url("~assets/findlawchild/xxitem_bg3.png");
      }
      &:nth-child(4n + 0) {
        background: url("~assets/findlawchild/xxitem_bg4.png");
      }
      &:nth-child(5n + 0) {
        background: url("~assets/findlawchild/xxitem_bg5.png");
      }
      &:nth-child(6n + 0) {
        background: url("~assets/findlawchild/xxitem_bg6.png");
      }
      &:nth-child(7n + 0) {
        background: url("~assets/findlawchild/xxitem_bg7.png");
      }
      &:nth-child(8n + 0) {
        background: url("~assets/findlawchild/xxitem_bg8.png");
      }
    }
  }
}
</style>